<script>
export default {
  name: "ba7-workshops",
  props: ['view'],
  methods: {
    open(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<template>
  <div class="ba7-workshops">
    <builderall-loader>
      <div class='ba-card'>
        <div class='ba-top'>
          <div class='ba-flex ba-f-column'>
            <span class='ba-title'>{{ view.translations.lastest_from_builderall_learn }}</span>
          </div>
        </div>
        <div class='ba-content'>
          <div
            class="ba-learn-card"
            v-for="(w, i) in view.workshops"
            :key="i"
          >
            <img class="cursor-pointer ba-shadow-8" @click="open(w.link)" :src="w.img" alt="">
            <span class="ba-title">
              {{ w.text.length > 25 ? w.text.substring(0, 25)+'...' : w.text }}
            </span>
          </div>
        </div>
      </div>
    </builderall-loader>
  </div>
</template>

<style scoped lang="scss">
.ba-card {
  height: 100%;
  .ba-content {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-content: center;
    gap: 15px;
    .ba-learn-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      img {
        height: 305px;
        border-radius: 20px;
      }
      span {
        width: 70%;
        color: #2A3C51;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/funnels/index.vue